import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import Balancer from "react-wrap-balancer";
import { useIntercom } from "hooks/use-intercom";
import { Button } from "ui/button";
import { TextTitle } from "ui/text";
import { Rule } from "ui/rule";
import { Section } from "./section";

type CatalogCTAProps = {
  heading?: string;
  chatButtonText: string;
  chatButtonDescription: string;
  chatPrompt: string;
  linkText: string;
  linkDescription: string;
  linkHref: string;
};

export function CatalogCTA({
  heading = "Don't see what you're looking for?",
  chatButtonText,
  chatButtonDescription,
  chatPrompt,
  linkText,
  linkDescription,
  linkHref,
}: CatalogCTAProps) {
  const { newChat } = useIntercom();

  const requestClick = (chatPrompt: string) => {
    newChat(chatPrompt);
  };

  return (
    <Section bg="new.green.950" theme="dark" themeBgColor="new.green.950" py={0}>
      <Flex
        maxW="4xl"
        mx="auto"
        direction="column"
        align="center"
        justify="center"
        textAlign="center"
        gap={{ base: "bigger", md: "biggest" }}
        py="huge"
      >
        <TextTitle theme="dark" size="xl" align="center" px="small" title={<Balancer>{heading}</Balancer>} />

        <Flex direction={{ base: "column", md: "row" }} gap={{ base: "big", md: 0 }} color="brand.textSecondary.dark">
          <Flex
            direction="column"
            align={{ base: "start", md: "center" }}
            px={{ base: "small", md: "bigger", lg: "biggest" }}
            py={{ base: 0, md: "smaller" }}
            w="100%"
          >
            <Button
              onClick={() => {
                requestClick(chatPrompt);
              }}
            >
              {chatButtonText}
            </Button>

            <Text align={{ base: "left", md: "center" }} textStyle="caption1" pt="big">
              {chatButtonDescription}
            </Text>
          </Flex>

          <Box w="1px" bg="brand.border.dark" display={{ base: "none", md: "block" }} />

          <Flex
            direction="column"
            align={{ base: "start", md: "center" }}
            px={{ base: "small", md: "bigger", lg: "biggest" }}
            py={{ base: 0, md: "smaller" }}
            w="100%"
          >
            <Button variant="secondary" href={linkHref}>
              {linkText}
            </Button>

            <Text align={{ base: "left", md: "center" }} textStyle="caption1" pt="big">
              {linkDescription}
            </Text>
          </Flex>
        </Flex>
      </Flex>

      <Rule theme="dark" />
    </Section>
  );
}
